define('app/views/ga_product_impression_helper',['app/setup'], function(takhfifan) {

  takhfifan.gaProductImpressionHelper = Backbone.View.extend({
    events: {},
    initialize: function (options) {
      var _this = this;
      this.deals = [];
      this.currentDeal = undefined;
      takhfifan.eventHub.on('ga:productImpression', function(data) {
        this.addImpression(data);
      }, this);

      takhfifan.eventHub.on('ga:promoImpression', function(data) {
        if(_this.gaEnabled()) {
          _.each(data, function(deal){
            ga('ec:addPromo', deal);
          });
        }
        this.sendData();
      }, this);

      takhfifan.eventHub.on('ga:productDetailImpression', function(data) {
        this.currentDeal = data;
      }, this);

      takhfifan.eventHub.on('ga:addToCart', function(data) {
        this.currentDeal = _.extend(this.currentDeal, data);
        if(_this.gaEnabled() && data) {
          ga("ec:addProduct", this.currentDeal);
          ga("ec:setAction", "add");
          // ga("send", "event", "EC-actions", "click", "addToCart");
        }
      }, this);

      takhfifan.eventHub.on('ga:removeFromCart', function(data) {
        if(_this.gaEnabled()){
          ga("ec:addProduct", data);
          ga("ec:setAction", "remove");
          ga("send", "event", "EC-actions", "click", "removeFromCart");
        }
      });

      takhfifan.eventHub.on('ga:checkoutOption', function(data) {
        if(_this.gaEnabled()){
          ga('ec:setAction', 'checkout_option', data);
          ga('send', 'event', 'Checkout', 'Option');
        }
      });

      //product click
      $(document).on('click', '.deal[data-details]', function (e) {
        if(_.isFunction(window.ga)) {
          e.preventDefault();
          var $this = $(this),
            productDetails = $this.data('details'),
            productList = productDetails.list,
            productInfo =  _.omit(productDetails, 'list'),
            productPageUrl = $this.find('a').attr('href');

          $this.addClass('disable');
          setTimeout(function() {document.location = productPageUrl;}, 2000);

          ga('ec:addProduct', productInfo);
          ga('ec:setAction', 'click', {list: productList});
          ga('send', 'event', 'UX', 'click', 'Results', {
            hitCallback: function() {
              document.location = productPageUrl;
            }
          });
        }
      });

      //promotions: impression
      $('.ga-promo-item:not(.ga-promo-item--hidden)[data-details]').each(function(){
        if(_this.gaEnabled()) {
          ga('ec:addPromo', $(this).data('details'));
          _this.sendData();
        }
      });

      //promotions: click
      $(document).on('click', '.ga-promo-item, .ga-promo-item a', function (e) {
        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'EC-promo', 'click');
      });
    },

    gaEnabled: function () {
      return _.isFunction(window.ga);
    },

    addImpression: function (deals) {
      var _this = this;
      _.each(deals, function(deal){
        if(_this.gaEnabled()){
          for(var i=0, l=_this.deals.length; i < l ; i++){
            var decodedDeal = _this.deals.shift();
            if (typeof(decodedDeal.list) !== 'undefined') {
              decodedDeal.list = decodeURI(decodedDeal.list);
              ga('ec:addImpression', decodedDeal);
            }
          }
          if (typeof(deal.list) !== 'undefined') {
            deal.list = decodeURI(deal.list);
            ga('ec:addImpression', deal);
          }
        }else{
          _this.deals.push(deal);
        }
      });
      this.sendData();
    },

    sendData: _.debounce(function () {
      if(this.gaEnabled()) {
        ga('send', 'event', 'EC', 'impression');
      }
    }, 1000)

  })
});
